import { EditorView, NodeType } from '@lyearn/lygo-core';

export type nodeAttributes = {
  id: string;
  type: NodeType;
};

export const performanceRegister = (
  view: EditorView,
  callback: (visibleNodesAttrs: nodeAttributes[]) => void,
  proseMirrorNodeDOMMap: Map<any, any> | null,
) => {
  if (proseMirrorNodeDOMMap) {
    const visibleNodesAttrs = [];
    // @ts-ignore
    for (const [keyNode, domElement] of proseMirrorNodeDOMMap) {
      const domElementRect = domElement.getBoundingClientRect();

      //if element is present in DOM but is hidden, do not register it's performance
      if (domElementRect.width === 0 && domElementRect.height === 0) {
        continue;
      }

      // As soon as the element comes in the bottom viewport, we're considering it.
      if (domElementRect.bottom >= 0 && domElementRect.bottom < globalThis.innerHeight) {
        visibleNodesAttrs.push({ id: keyNode.attrs.id, type: keyNode.type });
      }
    }
    if (visibleNodesAttrs.length) {
      console.debug(
        `[performanceRegister] calling the callback function on scroll with visibleNodesAttrs length ${visibleNodesAttrs.length}`,
      );
      callback(visibleNodesAttrs);
    }
  } else {
    console.error(
      '[performanceRegister] prosemirror nodes and corresponsing clientrect map not found',
    );
  }
};
